import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import * as z from "zod";

export const getUserFeatureFlag = {
  name: "getUserFeatureFlag" as const,
  input: z.object({
    email: z.string().email(),
    flagKey: z.enum(FeatureFlagKey),
  }),
  output: z.object({ value: z.boolean() }),
};
